/**
 *
 *
 * @author Erik Jan Lam
 * @date Jan 23 2019
 */

const $ = require('jquery');
const urlUtil = require('../utils/url');

const defaults = {
    minicartSelector: '.shopping-bag',
    minicartFlyoutSelector: '.minicart-1774',
    quantitySelector: '.minicart-qty',
    btnRemoveItemSelector: '.remove-product'
};
let settings = $.extend({}, defaults);

const miniCart = {
    /**
     * @param {Object?} options - parameters
     */
    init(options) {
        settings = $.extend({}, defaults, options || {});
        const $root = $(settings.minicartFlyoutSelector);
        if ($root.length) {
            $root.on('click', settings.btnRemoveItemSelector, function (event) {
                event.preventDefault();
                miniCart.removeFromCart(event.currentTarget);
            });
        }
    },
    /**
     * @param {Object?} options - parameters
     */
    setOptions(options) {
        settings = $.extend({}, defaults, options || {});
    },
    /**
     * @param {string} html - cart html
     * @param {number | undefined} quantity - quantity
     */
    update(html, quantity) {
        $(settings.minicartFlyoutSelector).html(html);
        if (quantity !== undefined) {
            miniCart.updateQuantity(quantity);
        }
    },

    /**
     * @param {number} quantity - quantity
     */
    updateQuantity(quantity) {
        $(settings.quantitySelector).text(quantity);
        $(settings.minicartSelector).attr('data-count', quantity);
    },

    /**
     * Removes a product from cart and shows updated mini cart
     *
     * @param {HTMLElement} trigger the click target
     */
    removeFromCart(trigger) {
        const $target = $(trigger);
        const uuid = $target.data('uuid');
        const url = urlUtil.ajaxUrl(
            $target.hasClass('giftcert-item') ? Urls.removeGiftCertificate : Urls.removeProduct
        );
        let data;

        if (uuid !== undefined) {
            data = {uuid};

            $.ajax({
                type: 'POST',
                url,
                data,
                /**
                 * @param {string} response - response body
                 */
                success(response) {
                    const chunks = miniCart.getResponseChunks(response);
                    if (chunks?.data?.removeProductTrackingData) {
                        window?.dataLayer?.push(chunks.data.removeProductTrackingData);
                    }
                    miniCart.update(chunks.minicart, chunks.data.qty);
                }
            });
        }
    },

    /**
     * don't know why this is here
     */
    show() {},

    /**
     * @typedef {Object} ResponseChunks
     * @property {Object} data - Additional data
     * @property {string?} minicart - minicart html
     * @property {string?} cartOverlay - cartOverlay html
     */

    /**
     *
     * @param {string} response - response body
     * @returns {ResponseChunks} - deserialized chunks from response
     */
    getResponseChunks(response) {
        const result = {data: {}};
        const chunks = response.split('%$%$%$SPLITME%$%$%$');
        let serializedData;
        [result.minicart, serializedData, result.cartOverlay] = chunks;

        if (serializedData) {
            try {
                const data = JSON.parse(serializedData);
                if (data) {
                    result.data = data;
                }
            } catch (e) {
                /* empty */
            }
        }

        return result;
    }
};

exports.miniCart = miniCart;
